import { html, when, ref } from '@microsoft/fast-element';
import type { ContactForm } from './contact-form.js';
import { twoWay } from '@microsoft/fast-element/binding/two-way.js';

export default html<ContactForm>`
	<form ${ref('form')} @submit=${x => x.handleSubmit()} novalidate ?inert=${x => x.received}>
		<adaptive-text-field
			name="firstname"
			placeholder="enter text"
			autocomplete="given-name"
			required
		>
			First Name
			<sup>*</sup>
		</adaptive-text-field>
		<adaptive-text-field
			name="lastname"
			placeholder="enter text"
			autocomplete="family-name"
			required
		>
			Last Name
			<sup>*</sup>
		</adaptive-text-field>
		<adaptive-text-field
			name="email"
			placeholder="enter text"
			type="email"
			autocomplete="email"
			required
		>
			Email
			<sup>*</sup>
		</adaptive-text-field>
		<adaptive-text-field
			name="phonenumber"
			placeholder="enter number"
			type="tel"
			autocomplete="tel"
			maxlength="10"
		>
			Phone Number
		</adaptive-text-field>
		<adaptive-text-field
			name="company"
			placeholder="enter text"
			autocomplete="organization"
			required
		>
			Company
			<sup>*</sup>
		</adaptive-text-field>
		<adaptive-text-field
			name="title"
			placeholder="enter text"
			autocomplete="organization-title"
		>
			Job Title
		</adaptive-text-field>
		<div class="message-wrapper">
			<adaptive-text-area
				name="message"
				placeholder="enter message (400 characters max)"
				maxlength="400"
				rows="5"
				required
			>
				Message
				<sup>*</sup>
			</adaptive-text-area>
		</div>
		<div class="actions">
			<adaptive-button
				type="submit"
				appearance=${x => x.isDarkMode ? "accent" : "lightweight"}
				?disabled=${x => x.received}
			>
				<svg slot="start" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" d="M1.724 1.053a.5.5 0 0 0-.714.545l1.403 4.85a.5.5 0 0 0 .397.354l5.69.953c.268.053.268.437 0 .49l-5.69.953a.5.5 0 0 0-.397.354l-1.403 4.85a.5.5 0 0 0 .714.545l13-6.5a.5.5 0 0 0 0-.894l-13-6.5Z"/></svg>
				${when(x => x.received, html`Thank You!`, html`Send Message`)}
			</adaptive-button>
		</div>
	</form>
`;